import { Button } from "./ui/button";
import { Card, CardHeader, CardTitle, CardContent } from "./ui/card";
import { ReloadIcon } from "@radix-ui/react-icons";
import { User } from "../lib/types";
import { ColumnDef, ColumnFiltersState } from "@tanstack/react-table"
import { DataTable } from "./ui/data-table";
import { ScrollArea } from './ui/scroll-area';
import UpdateSubscriptions from './users/UpdateSubscriptions';
import UpdateTokens from './users/UpdateTokens';
import CreateUser from './users/CreateUser';
import { ArrowUpDown } from "lucide-react";

export const userTableColumns: ColumnDef<User>[] = [
    {
      accessorKey: "user_id",
      header: "ID",
    },
    {
      accessorKey: "user_email",
      header: "Email",
      cell: ({ row, table }) => {
        return <Button type="button" variant="link" onClick={() => (table.options.meta as any)?.showSessions(row.original)}>{row.original.user_email}</Button>
      }
    },
    {
      accessorKey: "user_name",
      header: "Name",
      cell: ({ row, table }) => {
        return <Button type="button" variant="link" onClick={() => (table.options.meta as any)?.showSessions(row.original)}>{row.original.user_name}</Button>
      }
    },
    {
      accessorKey: "subscriptions",
      header: "Subscriptions",
      cell: ({ row, table }) => {
        return <UpdateSubscriptions user={row.original} refreshRowData={(table.options.meta as any)?.refreshRowData}/>
      }
    },
    {
      accessorKey: "user_tokens",
      header: "Tokens",
      cell: ({ row, table }) => {
        return <UpdateTokens user={row.original} refreshRowData={(table.options.meta as any)?.refreshRowData}/>
      }
    },
    {
      accessorKey: "created_at",
      header: "Creation date",
      cell: ({row}) => {
        return <span>{new Date(row.original.created_at + 'Z' ).toLocaleString(navigator.language)}</span>
      }
    },
    {
      accessorKey: "updated_at",
      header: ({ column }) => {
        return (
          <Button
            variant="ghost"
            onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
          >
            Last used date
            <ArrowUpDown className="ml-2 h-4 w-4" />
          </Button>
        )
      },
      sortingFn: 'alphanumericCaseSensitive',
      cell: ({row}) => {
        return <span>{row.original.updated_at ? new Date(row.original.updated_at + 'Z').toLocaleString(navigator.language) : ""}</span>
      }
    },
  ];

  export const userTableFilterColumns: ColumnFiltersState = [
    {
      id: "user_email",
      value: "",
    },
  ];

export default function UserComponent({users, refreshUsers, showUserSessions}: {users: User[], refreshUsers: () => void, showUserSessions: (user: User) => void}) {
  
  return (
    <Card className="h-full flex flex-col">
        <CardHeader className="pl-6 pb-1">
          <CardTitle className='flex items-center justify-between'>
            <div className="flex items-center">
              <span>Users</span>
              <Button onClick={refreshUsers} size={'icon'} variant={'outline'} className="ml-2 border-0">
                  <ReloadIcon className="w-4 h-3 stroke-4" />
              </Button>
            </div>
            <CreateUser refreshUsers={refreshUsers}/>
          </CardTitle>
        </CardHeader>
        <CardContent className="flex-1 overflow-hidden">
            <ScrollArea type='scroll' className="overflow-y-auto h-full">
              <DataTable 
                columns={userTableColumns} 
                data={users}
                showSessions={showUserSessions}
                filterColumns={userTableFilterColumns}
                refreshRowData={refreshUsers}
              />
            </ScrollArea>
        </CardContent>
    </Card>
  );
}